import toastr from 'toastr';

import * as actions from './actionsTypes';
import errorManage from '../../../errorManage';
import messages from '../../../messages';
import surveyTemplateQuestionServices from './surveyTemplateQuestions.services';
import SurveyTemplateQuestionOptionsServices from './surveyTemplateQuestionOptions.services';
import surveyTemplateQuestionOptionsServices from './surveyTemplateQuestionOptions.services';

export const getSurveyTemplateQuestions = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST, payload: true });
  try {
    const response = await  surveyTemplateQuestionServices.getSurveyTemplateQuestions(params);
    let questions = response.data;
    questions.sort((a, b) => a.secuence - b.secuence);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_SUCCESS, payload: questions });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST, payload: false });
  }
};

export const getSurveyTemplateQuestionById = (id) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: true });
  try {
    const response = await surveyTemplateQuestionServices.getSurveyTemplateQuestionById(id);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTION_SUCCESS, payload: response.data });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATE_QUESTION_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: false });
  } 
}

export const createSurveyQuestionTemplate = ({question, options, combinations}, setShow) => async (dispatch) => {
  dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: true });
  try {
    /*const promises = [surveyTemplateQuestionServices.saveSurveyTemplateQuestion(question)];
    if(options.length > 0){
      promises.push(SurveyTemplateQuestionOptionsServices.saveSurveyTemplateQuestionOption(options));
    }*/
   debugger
    const response = await surveyTemplateQuestionServices.saveSurveyTemplateQuestion(question) //await Promise.all(promises);
    dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_QUESTION_SUCCESS, payload: response.data });
    if (options.length > 0) {
      //add to options question_id
      options.forEach(option => option.question = response.data.id);
      const responseOpt = await SurveyTemplateQuestionOptionsServices.saveSurveyTemplateQuestionOption({options, combinations});
      let _options = responseOpt.data;
      _options.options.sort((a, b) => a.secuence - b.secuence);
      dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS, payload: _options }); 
    }
    dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_QUESTION_FAILURE, payload: "" });
    setShow(false);
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.CREATE_SURVEY_TEMPLATE_QUESTION_FAILURE);
  }finally{
    dispatch({ type: actions.CREATE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: false });
  }
};

export const updateSurveyQuestionTemplate = (id, {question, options, combinations}, setShow) => async (dispatch) => {
  dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: true });
  try {
    debugger
    const promises = [surveyTemplateQuestionServices.editSurveyTemplateQuestion(id, question)];
    if(options.length > 0){
      promises.push(SurveyTemplateQuestionOptionsServices.saveSurveyTemplateQuestionOption({options, combinations}));
    }
    const response = await Promise.all(promises);
    dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_QUESTION_SUCCESS, payload: response[0].data });
    if (options.length > 0) {
      let _options = response[1].data;
      _options.options.sort((a, b) => a.secuence - b.secuence);
      dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS, payload: _options });
    }
    dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_QUESTION_FAILURE, payload: "" });
    setShow(false);
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.UPDATE_SURVEY_TEMPLATE_QUESTION_FAILURE);
  }finally{
    dispatch({ type: actions.UPDATE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: false });
  }
}

export const updateSurveyQuestionTemplateSecuence = (data) => async (dispatch, getState) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST, payload: true });
  try {
    await surveyTemplateQuestionServices.updateSurveyTemplateQuestionSecuence(data);
    const { surveyTemplateQuestions } = getState().surveyTemplateQuestions;
    const surveyTemplateQuestionsCopy = surveyTemplateQuestions.slice();
    surveyTemplateQuestionsCopy.forEach((question) => {
      const item = data.data.find((item) => item.id === question.id);
      if(item){
        question.secuence = item.secuence;
      }
    });
    surveyTemplateQuestionsCopy.sort((a, b) => a.secuence - b.secuence);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_SUCCESS, payload: surveyTemplateQuestionsCopy });
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_REQUEST, payload: false });
  }
}

export const deleteSurveyQuestionTemplate = (id) => async (dispatch) => {

  dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: true });
  try {
    await surveyTemplateQuestionServices.deleteSurveyTemplateQuestion(id);
    dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_SUCCESS, payload: id });
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.DELETE_SURVEY_TEMPLATE_QUESTION_FAILURE);
  }finally{
    dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_REQUEST, payload: false });
  }
}

export const getSurveyTemplateQuestionsOptions = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_REQUEST, payload: true });
  try {
    debugger
    const response = await  surveyTemplateQuestionOptionsServices.getSurveyTemplateQuestionOptions(params);
    let {options, combinations} = response.data;
    options.sort((a, b) => a.secuence - b.secuence);
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS, payload: {options, combinations} });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_REQUEST, payload: false });
  }
};

export const deleteSurveyQuestionOption = (id) => async (dispatch, getState) => {
  dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_REQUEST, payload: true });
  try {
    await surveyTemplateQuestionOptionsServices.deleteSurveyTemplateQuestionOption(id);
    const { surveyTemplateQuestionOptions } = getState().surveyTemplateQuestions;
    const surveyTemplateQuestionOptionsCopy = surveyTemplateQuestionOptions.filter((option) => option.id !== id);
    dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_SUCCESS, payload: surveyTemplateQuestionOptionsCopy });
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_FAILURE);
  }finally{
    dispatch({ type: actions.DELETE_SURVEY_TEMPLATE_QUESTION_OPTIONS_REQUEST, payload: false });
  }
}

export const resetQuestion = () => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTION_SUCCESS, payload: {} });
  dispatch({ type: actions.FETCH_SURVEY_TEMPLATE_QUESTIONS_OPTIONS_SUCCESS, payload: {
    options: [],
    combinations: []
  } });
}